import { AnimatePresence, motion } from 'framer-motion'
import RoundedButton, {
  RoundedButtonProps,
} from '@/shared/components/buttons/rounded-button'
import React, { ReactNode } from 'react'

type ComponentProps = {
  delay?: number
}

type Props = {
  onClick?: () => void

  backdropProps?: ComponentProps
  buttonContainerProps?: ComponentProps
  buttonProps?: Omit<RoundedButtonProps, 'children'> & { children?: ReactNode }

  initial?: boolean
  show?: boolean
  disabled?: boolean
}

export default function BottomContinueButton({
  onClick,
  backdropProps,
  buttonContainerProps,
  buttonProps,
  initial,
  show,
  disabled,
}: Props) {
  const children = buttonProps?.children ?? 'Continue'

  return (
    <AnimatePresence mode="wait" initial={initial}>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            ease: 'easeOut',
            ...(backdropProps ? backdropProps : {}),
          }}
        >
          <div className="pointer-events-none fixed bottom-0 left-0 right-0 z-10 flex h-28 items-end justify-center bg-white/50 blur-md" />
          <motion.div
            className="fixed inset-x-0 bottom-0 z-20 mx-auto flex max-w-3xl justify-center px-6 pb-6 sm:px-8 lg:px-10"
            initial={{ opacity: 0, y: '20%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '20%' }}
            transition={{
              ease: 'easeOut',
              ...(buttonContainerProps ? buttonContainerProps : {}),
            }}
          >
            <RoundedButton
              disabled={disabled}
              onClick={onClick}
              {...buttonProps}
            >
              {children}
            </RoundedButton>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
